"use client";

import { useParams } from "next/navigation";

function useCommunityAndChannelParams() {
	const params = useParams();
	const communitySlugFromParams = params["community-slug"] as string;
	const channelSlugFromParams = params["channel-slug"] as string | undefined;

	return {
		// NOTE: Default to general-discussion-board to fetch channels during post creation
		communitySlug: communitySlugFromParams || "global-proptech-forum",
		channelSlug: channelSlugFromParams,
		isPublicFeed: !communitySlugFromParams,
	};
}

export default useCommunityAndChannelParams;
